module.exports = __webpack_public_path__ + "img/martini-glass-empty.bed6eb55.svg";